<script setup>
import { computed } from 'vue';
import { useMessageContext } from '../provider.js';

const { attachments, contentAttributes } = useMessageContext();

const stickerUrl = computed(() => {
  // Try to get sticker URL from attachments first
  if (attachments.value && attachments.value.length > 0) {
    const attachment = attachments.value[0];
    return (
      attachment.dataUrl ||
      attachment.data_url ||
      attachment.thumbUrl ||
      attachment.thumb_url
    );
  }

  // Try to get from content_attributes
  const attrs = contentAttributes.value || {};
  return (
    attrs.sticker_url || attrs.stickerUrl || attrs.url || attrs.media_url || ''
  );
});
</script>

<template>
  <div class="sticker-bubble max-w-[200px] p-1" data-bubble-name="sticker">
    <img
      v-if="stickerUrl"
      :src="stickerUrl"
      alt="Sticker"
      class="max-w-full max-h-[200px] object-contain rounded-lg"
      :class="{ 'animate-pulse': !stickerUrl }"
      loading="lazy"
    />
    <div
      v-else
      class="w-32 h-32 bg-n-alpha-2 rounded-lg flex items-center justify-center"
    >
      <!-- eslint-disable-next-line vue/no-bare-strings-in-template -->
      <span class="text-4xl">&#128444;</span>
    </div>
  </div>
</template>

<style scoped>
.sticker-bubble img {
  background: transparent;
}
</style>
